"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var create_exports = {};
__export(create_exports, {
  globalAdminRole: () => globalAdminRole,
  globalRole: () => globalRole,
  mapViewerRole: () => mapViewerRole,
  projectApproverRole: () => projectApproverRole,
  projectCoordinatorRole: () => projectCoordinatorRole,
  projectMemberRole: () => projectMemberRole,
  projectRole: () => projectRole,
  projectSurveyorRole: () => projectSurveyorRole,
  superuserRole: () => superuserRole,
  teamApproverRole: () => teamApproverRole,
  teamCoordinatorRole: () => teamCoordinatorRole,
  teamMemberRole: () => teamMemberRole,
  teamRole: () => teamRole,
  teamSurveyorRole: () => teamSurveyorRole,
  workspaceActiveRole: () => workspaceActiveRole,
  workspaceAdminRole: () => workspaceAdminRole,
  workspaceDisabledRole: () => workspaceDisabledRole,
  workspaceOwnerRole: () => workspaceOwnerRole,
  workspaceRole: () => workspaceRole
});
module.exports = __toCommonJS(create_exports);
var import_internal = require("./internal.js");
function globalRole(name) {
  return (0, import_internal.unsafeRole)(`G:${name}`);
}
function workspaceRole(name, workspaceId) {
  return (0, import_internal.unsafeRole)(`W:${name}:${workspaceId}`);
}
function projectRole(name, projectId) {
  return (0, import_internal.unsafeRole)(`P:${name}:${projectId}`);
}
function teamRole(name, teamId) {
  return (0, import_internal.unsafeRole)(`T:${name}:${teamId}`);
}
const superuserRole = globalRole("Superuser");
const globalAdminRole = globalRole("Admin");
const mapViewerRole = globalRole("MapViewer");
function workspaceDisabledRole(workspaceId) {
  return workspaceRole("Disabled", workspaceId);
}
function workspaceActiveRole(workspaceId) {
  return workspaceRole("Active", workspaceId);
}
function workspaceAdminRole(workspaceId) {
  return workspaceRole("Admin", workspaceId);
}
function workspaceOwnerRole(workspaceId) {
  return workspaceRole("Owner", workspaceId);
}
function projectMemberRole(projectId) {
  return projectRole("Member", projectId);
}
function projectSurveyorRole(projectId) {
  return projectRole("Surveyor", projectId);
}
function projectApproverRole(projectId) {
  return projectRole("Approver", projectId);
}
function projectCoordinatorRole(projectId) {
  return projectRole("Coordinator", projectId);
}
function teamMemberRole(teamId) {
  return teamRole("Member", teamId);
}
function teamSurveyorRole(teamId) {
  return teamRole("Surveyor", teamId);
}
function teamApproverRole(teamId) {
  return teamRole("Approver", teamId);
}
function teamCoordinatorRole(teamId) {
  return teamRole("Coordinator", teamId);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  globalAdminRole,
  globalRole,
  mapViewerRole,
  projectApproverRole,
  projectCoordinatorRole,
  projectMemberRole,
  projectRole,
  projectSurveyorRole,
  superuserRole,
  teamApproverRole,
  teamCoordinatorRole,
  teamMemberRole,
  teamRole,
  teamSurveyorRole,
  workspaceActiveRole,
  workspaceAdminRole,
  workspaceDisabledRole,
  workspaceOwnerRole,
  workspaceRole
});
//# sourceMappingURL=create.js.map
